<script setup>
const { t } = useI18n()
</script>

<template>
  <AppLoginLogoutButtonTemplate
    url="/logout"
    icon="i-far-right-from-bracket"
    :label="t('Log out')"
  />
</template>

<i18n>
{
  "en-us": {
    "Log out": "Log out"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Log out": "Abmelden"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Log out": "Se déconnecter"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Log out": "Finalizar sesión"
}
</i18n>
